import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'chart.js';

if (environment.production) {
  enableProdMode();
}

const EventEmitter = require('events');
EventEmitter.defaultMaxListeners = 300;

platformBrowserDynamic().bootstrapModule(AppModule);
